import { render, staticRenderFns } from "./Subcostos.vue?vue&type=template&id=e723c2c2"
import script from "./Subcostos.vue?vue&type=script&lang=js"
export * from "./Subcostos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports